const radConfig = {
  allottement_status: false,
  currentUrl: "https://central.aikenist.com/",
  previousVisitUrl: "https://medapps.medallcorp.in",
  baseUrl: "https://central.aikenist.com/api/quickrad",
  baseUrlRadio: "https://central.aikenist.com/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://central.aikenist.com/aikenviewer/viewer/",
  abdmBaseUrl: "https://abdm.aikenist.com",
  viewer3DURL:"https://central.aikenist.com/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://central.aikenist.com/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://central.aikenist.com/3daikenviewer/microscopy?StudyInstanceUIDs=",
  viewerSeg:"https://central.aikenist.com/3daikenviewer/segmentation?StudyInstanceUIDs=",
  viewerECG: "https://central.aikenist.com/3daikenviewer/ecg?StudyInstanceUIDs=",
  viewerMultiple: "https://central.aikenist.com/3daikenviewer/viewer?",
  viewerMultiplePet: "https://central.aikenist.com/3daikenviewer/tmtv?",
  medDream:"https://central.aikenist.com/?study=",
  thumbnailURL: "https://central.aikenist.com/dicom-web/instances/",
  gifURL:
  "https://central.aikenist.com/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://central.aikenist.com/dicom-web",
  weasisDicomWeb: "https://central.aikenist.com/dicom-web",
  studyList: "https://central.aikenist.com/dicom-web/studies",
  localViewer: "https://central.aikenist.com/aikenviewer/local",
  client: "central",
  paymentComplete: true,
  version: "v2.0",
  scannerAgentPort: 47821,
  metabaseSiteUrl: "https://metabase.aikenist.com",
  metabaseDashboardId: 2,
  metabaseBillingDashboardId: 3,
  metabaseEmbedSecret: "dc6f5251fdbedfe7884946ce6637cf337639e5eafb07ffebcb62bf197493185b",
  metabaseUseLockedParams: true,
  ezhealBaseUrl: "https://central.aikenist.com/billingbackend",
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp",
  speedTestUrl: "https://speed.cloudflare.com/__down",
  geoMapBaseUrl: "https://map.aikenist.com/api/v1",
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
